import { Home, MessageCircle, AlertCircle } from 'lucide-react';
import { navigate } from '@/hooks/useRouter';
import Button from '@/components/ui/Button';

export default function ErrorPage() {
  const handleGoHome = () => {
    navigate('/');
  };

  const handleContactSupport = () => {
    navigate('/customer-service');
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-bg-page px-6">
      {/* 错误图标 */}
      <div className="mb-8 p-6 bg-white rounded-full shadow-lg">
        <AlertCircle size={64} className="text-primary" />
      </div>

      {/* 错误标题 */}
      <h1 className="text-2xl font-bold text-text-primary mb-4">出错了</h1>

      {/* 错误描述 */}
      <p className="text-center text-text-secondary mb-12 max-w-sm">
        页面加载失败，可能是网络问题或页面暂时不可用，请稍后重试。
      </p>

      {/* 操作按钮 */}
      <div className="w-full max-w-sm space-y-3">
        <Button
          variant="primary"
          block
          round
          leftIcon={<Home size={20} />}
          onClick={handleGoHome}
        >
          返回首页
        </Button>

        <Button
          variant="ghost"
          block
          round
          leftIcon={<MessageCircle size={20} />}
          onClick={handleContactSupport}
        >
          联系客服
        </Button>
      </div>

      {/* 提示文字 */}
      <p className="mt-8 text-sm text-text-secondary/70">
        如问题持续存在，请联系客服获取帮助
      </p>
    </div>
  );
}
